import { BasicModal, Button } from '../../Shared';

export const SaveNumberModal = ({
  open,
  onClose,
  disabled,
  onAccept,
  onReject,
  description = '',
}) => {
  return (
    <BasicModal
      open={open}
      handleClose={disabled ? undefined : onClose}
      className="flex items-center justify-center w-full h-full"
    >
      <div className="bg-white w-[560px] rounded-[20px] shadow-[-40px_40px_80px_-8px_rgba(0,0,0,0.24)]">
        <div className="flex flex-col gap-1 pt-5 px-5 pb-4">
          <span className="text-base-1000 font-semibold text-[22px]/[28px]">
            Unsaved Number
          </span>
          <span className="text-base-1000 text-[18px]/[24px]">
            Number dialled was not recorder to contact profile.
            {!!description && (
              <>
                <br /> {description}
              </>
            )}
          </span>
        </div>
        <div className="flex items-center justify-end gap-3 py-4 px-5">
          <Button
            title="Proceed without saving"
            variant="blue"
            onClick={onReject}
            disabled={disabled}
          />
          <Button title="Save number" onClick={onAccept} disabled={disabled} />
        </div>
      </div>
    </BasicModal>
  );
};
